import { RequestStatus } from "./RequestStatus";

export enum RequestFileType {
  None = 0,
  Serviceable = 1,
  Unserviceable = 2,
  Info = 3,
  AarScopeInvestigation = 4, //Status 1
  AarProvideNecessary = 5, //Status 8
  ShippingInvoice = 6, // Unserviceable Create
  // QuarantineStage = 7,
  // QuarantineStageStep2 = 8,
  LastCertificateOrShopReportsOrPastActivityRelated = 9,
  AlternatePn = 10,
  Customer = 11,
  TT = 12,
  UsTag = 13,
}

export const GetRequestFileType = [
  // { Description: "None", Value: CarrierType.None },
  { Description: "Shipping Invoice", Value: RequestFileType.ShippingInvoice },
  {
    Description: "Last Certificate/Shop Reports/Past Activity Related",
    Value: RequestFileType.LastCertificateOrShopReportsOrPastActivityRelated,
  },
];

export const GetRequestFileGroupType = [
  // { Description: "None", Value: CarrierType.None },
  { Description: "Serviceable", Value: RequestFileType.Serviceable },
  { Description: "Core Unit", Value: RequestFileType.Unserviceable },
  { Description: "Info", Value: RequestFileType.Info },
];

export const GetRequestUnserviceableFileType = (requestStatus: RequestStatus) => {
  let requestUnsvcFileTypeArray = [
    { Description: "Shipping Invoice", Value: RequestFileType.ShippingInvoice },
    // { Description: "Quarantine Stage", Value: RequestFileType.QuarantineStage},
    // { Description: "Quarantine Stage Step 2", Value: RequestFileType.QuarantineStageStep2},
    {
      Description: "Last Certificate/Shop Reports/Past Activity Related",
      Value: RequestFileType.LastCertificateOrShopReportsOrPastActivityRelated,
    },
    {
      Description: "US TAG",
      Value: RequestFileType.UsTag,
    },
  ];

  if (requestStatus == RequestStatus.NotPool) {
    requestUnsvcFileTypeArray.push({
      Description: "AAR Scope Investigation (Status 1)",
      Value: RequestFileType.AarScopeInvestigation,
    });
  }

  if (requestStatus == RequestStatus.NotPlmsStatus) {
    requestUnsvcFileTypeArray.push({
      Description: "Aar Provide Necessary (Status 8)",
      Value: RequestFileType.AarProvideNecessary,
    });
  }

  return requestUnsvcFileTypeArray;
};
export const GetRequestAlternatePnFileType = () => {
  let fileTypeArray = [
    { Description: "Customer", Value: RequestFileType.Customer },
    {
      Description: "TT",
      Value: RequestFileType.TT,
    },
  ];

  return fileTypeArray;
};
